/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AntennaAUpdate
 */
export interface AntennaAUpdate {
    /**
     * 
     * @type {string}
     * @memberof AntennaAUpdate
     */
    eloshieldConfigurationId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AntennaAUpdate
     */
    antennaIndex?: number | null;
    /**
     * Height in decimeter.
     * @type {number}
     * @memberof AntennaAUpdate
     */
    heightDm?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AntennaAUpdate
     */
    zone1RadiusCm?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AntennaAUpdate
     */
    zone2RadiusCm?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AntennaAUpdate
     */
    mutingDistanceCm?: number | null;
}

/**
 * Check if a given object implements the AntennaAUpdate interface.
 */
export function instanceOfAntennaAUpdate(value: object): value is AntennaAUpdate {
    return true;
}

export function AntennaAUpdateFromJSON(json: any): AntennaAUpdate {
    return AntennaAUpdateFromJSONTyped(json, false);
}

export function AntennaAUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AntennaAUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'eloshieldConfigurationId': json['eloshieldConfigurationId'] == null ? undefined : json['eloshieldConfigurationId'],
        'antennaIndex': json['antennaIndex'] == null ? undefined : json['antennaIndex'],
        'heightDm': json['heightDm'] == null ? undefined : json['heightDm'],
        'zone1RadiusCm': json['zone1RadiusCm'] == null ? undefined : json['zone1RadiusCm'],
        'zone2RadiusCm': json['zone2RadiusCm'] == null ? undefined : json['zone2RadiusCm'],
        'mutingDistanceCm': json['mutingDistanceCm'] == null ? undefined : json['mutingDistanceCm'],
    };
}

export function AntennaAUpdateToJSON(json: any): AntennaAUpdate {
    return AntennaAUpdateToJSONTyped(json, false);
}

export function AntennaAUpdateToJSONTyped(value?: AntennaAUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eloshieldConfigurationId': value['eloshieldConfigurationId'],
        'antennaIndex': value['antennaIndex'],
        'heightDm': value['heightDm'],
        'zone1RadiusCm': value['zone1RadiusCm'],
        'zone2RadiusCm': value['zone2RadiusCm'],
        'mutingDistanceCm': value['mutingDistanceCm'],
    };
}

